import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const useCustomer = () => {
  const cubeContext = useCubeContext()

  const customerId = cubeContext.queries.rawData.data.common.customerId

  const customerQuery = useQuery(
    dashboardv99990101Client.getCustomer,
    {
      id: customerId ?? ''
    },
    {
      enabled: Boolean(customerId)
    }
  )

  return {
    isLoading: customerQuery.isPending,
    // True while a cached customer is being refetched too, so a caller that
    // acts on the *absence* of something can wait for the server rather than
    // trusting a stale copy.
    isFetching: customerQuery.isFetching,
    customer: customerQuery.data
  }
}
